import {
  IntegrationProviderEnum,
  IntegrationProviderType,
  IntegrationScopeEnum,
} from '@/types/schema';

import { useIntegrationProviderQuery } from '../../graphql/queries/generated/integrationProvider';

function useIntegrationProviderDetails({
  integrationProviderId,
  provider,
  scope,
  userId,
}: {
  integrationProviderId?: string;
  provider?: IntegrationProviderEnum;
  scope: IntegrationScopeEnum;
  userId?: string;
}) {
  const [{ data, fetching, error }, refetch] = useIntegrationProviderQuery({
    variables: {
      filters: {
        integrationProviderId,
        provider,
        scopes: [scope],
      },
      scope,
      userId,
    },
    pause: !integrationProviderId && !provider,
  });

  const integrationProvider = data?.integrationProvider.integrationProvider as
    | IntegrationProviderType
    | undefined;

  return {
    integrationProvider,
    fetching,
    refetch,
  };
}

export default useIntegrationProviderDetails;
